import { useEffect } from 'react';
import { useAppStore } from '../store/useAppStore';
import TopBar from './TopBar';
import Workbench from './Workbench';
import GroupChat from './GroupChat';

export default function MainInterface() {
  const { currentProjectId, projects, loadProjects, loadGods, setCurrentProject } = useAppStore();

  useEffect(() => {
    loadGods();
    loadProjects();
  }, [loadGods, loadProjects]);

  // 已登录且有项目但未选当前项目，默认选第一个
  useEffect(() => {
    if (!currentProjectId && projects.length > 0) {
      setCurrentProject(projects[0].id);
    }
  }, [currentProjectId, projects, setCurrentProject]);

  if (!currentProjectId) {
    return (
      <div id="main-interface" className="flex items-center justify-center h-screen text-gray-400">
        请先创建喜事项目
      </div>
    );
  }

  return (
    <div id="main-interface" className="flex flex-col h-screen" style={{ background: '#fdf6e3' }}>
      {/* 顶部信息区 */}
      <TopBar />

      {/* 主体：左工作台 + 右群聊 */}
      <div id="main-content" className="flex flex-1 overflow-hidden">
        {/* 左侧工作台 - 宽度 auto */}
        <div id="left-workbench" className="flex-1 overflow-hidden flex flex-col">
          <Workbench eventId={currentProjectId} />
        </div>

        {/* 右侧群聊 - 最小宽度 320px，默认 30% */}
        <div
          id="right-chat"
          className="flex-shrink-0 border-l-2 border-amber-100 overflow-hidden"
          style={{ width: '30%', minWidth: 320 }}
        >
          <GroupChat />
        </div>
      </div>
    </div>
  );
}
